import { pageNames } from '@atc/bonnet-paths';
import { getScaledImageSource, imageSizes } from '@atc/images';

import { mainImageSizes } from '@/containers/vdp/MediaGallery/sizes';

const { VEHICLE_DETAILS } = pageNames;

export default function getScaledPrimaryImg(pageName, browser, primaryImgSrc) {

    let primaryImageSize;
    let mediaGalleryImageSize = {};

    switch (pageName) {
        case VEHICLE_DETAILS: {
            primaryImageSize = browser?.is?.xs ? 'mediaViewerSm' : 'mediaViewerxLg';
            mediaGalleryImageSize = { ...mainImageSizes[browser?.mediaType] };
            break;
        }
        default:
            primaryImageSize = 'mediaViewerSm';
    }

    return getScaledImageSource({
        src: primaryImgSrc,
        bgColor: '2d363e',
        ...imageSizes[primaryImageSize],
        ...mediaGalleryImageSize,
    });
}
